var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 ma-md-2"},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[(_vm.section == 'capabilities')?_c('capabilities-box'):_vm._e(),(_vm.section == 'profiles')?_c('entitlements-box'):_vm._e(),(_vm.section == 'licenses')?_c('license-box'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }